import { render, staticRenderFns } from "./publish_method.vue.js?vue&type=template&id=87c631ba!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./publish_method.vue?vue&type=template&id=87c631ba"
import script from "./publish_method.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./publish_method.vue?vue&type=script&lang=js"
export * from "./publish_method.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./publish_method.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports